import { useMutation } from '@tanstack/react-query'

import { changeInvoiceEmail } from '@src/api'
import { DefaultApiChangeInvoiceEmailRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks'

export const useChangeInvoiceEmail = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiChangeInvoiceEmailRequest) =>
      changeInvoiceEmail(axiosInstance, params),
  })
}
